import { router } from "expo-router"
import BFText from "@/components/standard/BFText"
import { TouchableOpacity } from "react-native"

export const SignInLink = () => {
  return (
    <TouchableOpacity
      testID="sign-in-link"
      onPress={() => {
        router.push("/login")
      }}
    >
      <BFText className="text-white text-[12px] font-spacegrotesk text-center">
        Already a Member?&nbsp;
        <BFText className="underline text-teal font-spacegrotesk">
          Sign In
        </BFText>
      </BFText>
    </TouchableOpacity>
  )
}
